import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { VideoComponent } from '../video/video.component';
import { ActivatedRoute } from '@angular/router';
import { CampuscctvserviceService } from '../service/campuscctvservice.service';
@Component({
  selector: 'app-cctvcampus',
  templateUrl: './cctvcampus.component.html',
  styleUrls: ['./cctvcampus.component.scss']
})
export class CctvcampusComponent implements OnInit {
  dvr: any[] = [];
  constructor(private dailog: MatDialog, public campuscctvserviceservice: CampuscctvserviceService, private router: ActivatedRoute) { }
  ngOnInit(): void {
    const id = this.router.snapshot.params['id']
    this.campuscctvserviceservice.getCctvCampus(id).subscribe(
      {
        next: (httpResponse: any) => {
          this.dvr = httpResponse
          console.log('data', this.dvr);
        },
        error:(err:any)=>{
          console.log('Error',err);
        },
        complete:()=>{
          console.log('completed!');
          
        }
      }
    )

    // const id=this.router.snapshot.params['id']
    // this.http.get<any>('http://192.168.1.47:8180/ses/cctv/dvrDetails?cctvDetId='+id,).subscribe(Response=>{
    //   this.dvr=Response
    //   console.log(this.dvr);
    // })
  }
  openvideo() {
    this.dailog.open(VideoComponent, {
      width: '100%', height: '100%',
    })
  }
}

